import { CreditPlanRequirementsListModalComponent } from './credit-plan-requirements-list-modal/credit-plan-requirements-list-modal.component';
import { CreditRequestsInProcessComponent } from './credit-requests-in-process/credit-requests-in-process.component';
import { AdvanceCreateComponent } from './customer-advances/advance-create/advance-create.component';
import { CustomerAdvancesComponent } from './customer-advances/customer-advances.component';
import { CustomerBalanceRecordModalComponent } from './customer-balance-record-modal/customer-balance-record-modal.component';
import { CustomerCreditNotesComponent } from './customer-credit-notes/customer-credit-notes.component';
import { CustomerCreditPlansComponent } from './customer-credit-plans/customer-credit-plans.component';
import { CustomerCreditReferenceComponent } from './customer-credit-reference/customer-credit-reference.component';
import { CustomerCreditRequestStepperComponent } from './customer-credit-request-stepper/customer-credit-request-stepper.component';
import { CustomerCreditStatusComponent } from './customer-credit-status/customer-credit-status.component';
import { CustomerIdentificationComponent } from './customer-identification/customer-identification.component';
import { CustomerInformationDetailComponent } from './customer-information-detail/customer-information-detail.component';
import { CustomerInformationComponent } from './customer-information/customer-information.component';
import { CustomerLoansActiveComponent } from './customer-loans-active/customer-loans-active.component';
import { CustomerLoansCanceledComponent } from './customer-loans-canceled/customer-loans-canceled.component';
import { CustomerPhoneAndMailComponent } from './customer-phone-and-mail/customer-phone-and-mail.component';
import { CustomerPreApprovalFormComponent } from './customer-pre-approval-form/customer-pre-approval-form.component';
import { CustomerQuotationsComponent } from './customer-quotations/customer-quotations.component';
import { CustomerRecollectionListComponent } from './customer-recollection-list/customer-recollection-list.component';
import { CustomerVerifyPhoneAndEmailComponent } from './customer-verify-phone-and-email/customer-verify-phone-and-email.component';
import { FastActionsButtonsComponent } from './fast-actions-buttons/fast-actions-buttons.component';
import { PosCustomerComponent } from './pos-customer/pos-customer.component';
import { StandAloneReturnContractDetailComponent } from './stand-alone-return-contract-detail/stand-alone-return-contract-detail.component';
import { StandAloneReturnContractComponent } from './stand-alone-return-contract/stand-alone-return-contract.component';

export const components = [
  CustomerIdentificationComponent,
  CustomerInformationComponent,
  CustomerCreditRequestStepperComponent,
  CustomerPreApprovalFormComponent,
  PosCustomerComponent,
  CustomerCreditPlansComponent,
  CustomerLoansActiveComponent,
  CustomerCreditNotesComponent,
  CreditPlanRequirementsListModalComponent,
  FastActionsButtonsComponent,
  CustomerAdvancesComponent,
  CustomerCreditStatusComponent,
  CreditRequestsInProcessComponent,
  CustomerQuotationsComponent,
  StandAloneReturnContractComponent,
  StandAloneReturnContractDetailComponent,
  CustomerLoansCanceledComponent,
  CustomerRecollectionListComponent,
  CustomerBalanceRecordModalComponent,
  CustomerPhoneAndMailComponent,
  CustomerInformationDetailComponent,
  CustomerVerifyPhoneAndEmailComponent,
  CustomerCreditReferenceComponent,
  AdvanceCreateComponent
];

export * from './../components/customer-identification/customer-identification.component';
export * from './credit-plan-requirements-list-modal/credit-plan-requirements-list-modal.component';
export * from './customer-advances/advance-create/advance-create.component';
export * from './customer-advances/customer-advances.component';
export * from './customer-balance-record-modal/customer-balance-record-modal.component';
export * from './customer-credit-notes/customer-credit-notes.component';
export * from './customer-credit-plans/customer-credit-plans.component';
export * from './customer-credit-reference/customer-credit-reference.component';
export * from './customer-credit-request-stepper/customer-credit-request-stepper.component';
export * from './customer-credit-status/customer-credit-status.component';
export * from './customer-information-detail/customer-information-detail.component';
export * from './customer-information/customer-information.component';
export * from './customer-loans-active/customer-loans-active.component';
export * from './customer-phone-and-mail/customer-phone-and-mail.component';
export * from './customer-pre-approval-form/customer-pre-approval-form.component';
export * from './customer-quotations/customer-quotations.component';
export * from './customer-recollection-list/customer-recollection-list.component';
export * from './customer-verify-phone-and-email/customer-verify-phone-and-email.component';
export * from './fast-actions-buttons/fast-actions-buttons.component';
export * from './pos-customer/pos-customer.component';
export * from './stand-alone-return-contract-detail/stand-alone-return-contract-detail.component';
export * from './stand-alone-return-contract/stand-alone-return-contract.component';

